import { Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

export const useRatingNpsStyles = makeStyles()((theme: Theme) => ({
	radioWrapper: {
		"& > label": {
			margin: 0,
		},
		marginBottom: theme.spacing(2.5),
	},
}));
